import { Component,ElementRef, ViewChild, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, Validators } from '@angular/forms';
import { ImageCroppedEvent,LoadedImage, } from 'ngx-image-cropper';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.css']
})
export class ProfilePageComponent {
  selectedFile: File | null = null;
  imageChangedEvent: Event | null = null;
  croppedImage: string = ''; 
  profileImage: string = '';  
  dropboxLinks: string[] = [];  
  showPasswordDetails: boolean = false;
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  OldPassword =new FormControl();
  Password = new FormControl('', [Validators.required]);
  confirmPassword = new FormControl('', [Validators.required]);
  UserId:string="";
  Photo:string="";
  FirstName = new FormControl('', [Validators.required]);
  LastName = new FormControl('', [Validators.required]);
  MobileNumber = new FormControl('', [Validators.required,Validators.pattern("^[0-9]*$")]);
  AddressLineOne = new FormControl('', [Validators.required]);
  AddressLineTwo = new FormControl('', [Validators.required]);
  City = new FormControl('', [Validators.required]);
  State = new FormControl('', [Validators.required]);
  Pincode= new FormControl(' ',[Validators.required,Validators.pattern("^[0-9]{6}$")]);
  getSafeValue(value:string | null):string{
    return (value=== null || value === "undefined") ? "" : value;
  }


  constructor(private http: HttpClient,public service:SharkifyAiSerivceService,public app: AppComponent,private toastr: ToastrService ) {}

  @ViewChild('fileInput') fileInput: ElementRef | undefined; // Add this inside the class

  triggerFileInput():void {
     if (this.fileInput) {
    this.fileInput.nativeElement.click();
  } else {
    console.error('File input is not available');
  }
  }

  totalFields: number = 9;  // Total number of input fields (including gender dropdown)
  completedFields: number = 0;

  ngOnInit() {
    const formFields: NodeListOf<HTMLInputElement | HTMLSelectElement> = document.querySelectorAll('#profileForm input, #profileForm select');
    formFields.forEach(field => {
      field.addEventListener('input', () => this.updateProgress(formFields));
    });
    this.UserId=this.getSafeValue(localStorage.getItem("UserId"));
  }

  updateProgress(fields: NodeListOf<HTMLInputElement | HTMLSelectElement>) {
    this.completedFields = Array.from(fields).filter(field => field.value.trim() !== '').length;
    const completionPercentage = Math.round((this.completedFields / this.totalFields) * 100);
  
    const progressFill = document.getElementById('progressFill') as HTMLElement;
    const progressPercent = document.getElementById('progressPercent') as HTMLElement;
  
    // Update progress fill width
    progressFill.style.width = `${completionPercentage}%`;
  
    // Update percentage text
    progressPercent.textContent = `${completionPercentage}%`;
  }
  updatePassword(){
    this.showPasswordDetails=!this.showPasswordDetails;
  }

  passwordsMatch(): boolean {
    return this.Password.value === this.confirmPassword.value;
  }
  togglePasswordVisibility(field: string) {
    if (field === 'old') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  fileChangeEvent(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.imageChangedEvent = event;
    }
  }

  imageLoaded(image: LoadedImage) {
  }

  cropperReady() {
  }

  loadImageFailed() {
    console.error('Image loading failed.');
  }

  imageCropped(event: ImageCroppedEvent) {
    const objectUrl = event.objectUrl ?? event.base64; 
    if (objectUrl) {
      this.convertToBase64(objectUrl).then((base64: string) => {
        this.croppedImage = base64; 
      });
    }
  }

  ManagarSendImage(event: Event): void{
    this.app.displayLoader(true);
    event.preventDefault();
    if (this.croppedImage) {
      const formData = new FormData();
      formData.append('folderName','Sharkify')
      formData.append('userId','Manager '+ this.UserId)
      formData.append('folderType','Profile')
      // formData.append('file',this.croppedImage);
      formData.append('file',this.base64ToBlob(this.croppedImage), 'myProfile.png');

      this.service.UpdateAccountManagerProfilePhoto(formData, this.UserId).subscribe(
        (response) => {
          if (response) {
            this.profileImage = response.data.Image;
            this.service.updateUser(this.UserId, { Photo: this.profileImage }).subscribe(
              (updateResponse) => {
                this.toastr.success('Manager Image uploaded and profile updated successfully!', 'Success');
              },
              (error) => {
                this.toastr.error('Error updating user profile', 'Error');
                console.error('Error updating user profile:', error);
              }
            );
          }
          this.app.displayLoader(false);          
          if (response.links) {
            this.dropboxLinks = response.links; 
          }
        },
        (error) => {
          this.app.displayLoader(false);
          this.toastr.error('Error uploading cropped image', 'Error');
          console.error('Error uploading cropped image:', error);
        }
      );
    } else {
      this.toastr.error('Image uploading failed.', 'Error');
      this.app.displayLoader(false);
      console.warn('No cropped image available for upload.');
    }
  }
  base64ToBlob(base64: string): Blob {
    const byteString = atob(base64.split(',')[1]);
    const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
  ManagarUpdateButton(){
    this.app.displayLoader(true);
    if(this.FirstName.valid && this.LastName.valid && this.MobileNumber.valid && this.AddressLineOne.valid &&this.AddressLineTwo.valid && this.City.valid && this.State.valid && this.Pincode.valid)
    {
      this.service.UpdateClientProfileDetails(this.UserId,this.FirstName.value+"",this.LastName.value+"",this.MobileNumber.value+"", this.AddressLineOne.value+"", this.AddressLineTwo.value+"",this.City.value+"", this.State.value+"", this.Pincode.value+"").subscribe(data => {
        this.app.displayLoader(false);
        this.toastr.error('Manager Details successfully uploaded', 'Success');
      }, error => {
        this.app.displayLoader(false);
        this.toastr.error('Please fill the complete Manager details', 'Error');
      })
    }
    else{
      this.app.displayLoader(false);
      this.toastr.error('Please fill the complete details', 'Error');

    }

  }
  ManagarUpdatePasswors(){
    this.app.displayLoader(true);
    if(this.OldPassword.value != this.Password.value){
      if(this.Password.value ===this.confirmPassword.value){
      this.service.UpdateClientProfilePassword(this.UserId,this.OldPassword.value+"",this.Password.value+"").subscribe(data => {
        this.app.displayLoader(false);
        if(data.Code == 200)
          {
            this.toastr.error('Manager Password Updated Successfully', 'Success');
          }
          else{
            this.toastr.error('Manager Password Updation failed', 'Error');
          }
        
      })
    }

    }
    else{
      this.toastr.error('Old Password and New Password cannot be same', 'Error');
      this.app.displayLoader(false);
    }

  }

  dataURLtoBlob(dataURL: string): Blob {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type: mimeString });
  }

  convertToBase64(objectUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', objectUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (xhr.status === 200) {
          const reader = new FileReader();
          reader.onloadend = function() {
            resolve(reader.result as string);
          };
          reader.readAsDataURL(xhr.response);
        } else {
          reject(new Error('Failed to convert object URL to base64.'));
        }
      };
      xhr.onerror = function() {
        reject(new Error('Failed to convert object URL to base64.'));
      };
      xhr.send();
    });
  }
}

